import { useEffect, useState } from 'react';

import { useTheme } from '@/app/ThemeProvider';
import { readChartTheme, type ChartTheme } from './chartTheme';

/** Re-reads the token values whenever the resolved theme changes. */
export function useChartTheme(): ChartTheme {
  const { resolved } = useTheme();
  const [theme, setTheme] = useState<ChartTheme>(() => readChartTheme());

  useEffect(() => {
    // One frame after the attribute flips, so the new values are computed.
    const id = requestAnimationFrame(() => setTheme(readChartTheme()));
    return () => cancelAnimationFrame(id);
  }, [resolved]);

  return theme;
}
